
const hostname = window.location.hostname
const protocal = window.location.protocol

export const BASE_URL = hostname == 'www.xiaote.com' ? `https://lcen.xiaote.net` : `https://stg-lcen.xiaote.net`
export const WSS_URL = hostname == 'www.xiaote.com' ? `wss://lcen.xiaote.net` : `wss://lcen.xiaote.net`



// WEBPACK FOOTER //
// ./src/config/config.js